import React from 'react';
import {
	Edit,
	SimpleForm,
	TextInput,
	required,
	BooleanInput,
	ArrayInput,
	SimpleFormIterator,
	ReferenceInput,
	AutocompleteInput
  } from 'react-admin';
import { EditToolbar } from '../../../components/Toolbar/EditToolbar';

export const UserTypesEdit = (props) => (
	<Edit title='Edit Type' {...props}>
		<SimpleForm variant='standard' margin='normal' toolbar={<EditToolbar />}>
			<TextInput source='name' validate={required()} fullWidth />
			<TextInput source='description' fullWidth multiline />
			<BooleanInput source='requires_mfa' label='MFA?' fullWidth />
			<BooleanInput source='requires_kyc' label='KYC?' fullWidth />
			<BooleanInput source='is_client_accessible' label='Client Accessible?' fullWidth />
			<ReferenceInput
				label='Associated Role'
				source='associated_role_id'
				reference='roles'
				perPage={25}
				filterToQuery={(searchText) => ({
					q: searchText,
					_q_op: 'isw',
					_autocomplete: true
				})}
				sort={{ field: 'name', order: 'ASC' }}
				fullWidth
			>
				<AutocompleteInput 
					resettable 
					validate={required()} 
					matchSuggestion={(filterValue, suggestion) => true}
					optionText='name' 
				/>
			</ReferenceInput>
			<ArrayInput source="benefits">
				<SimpleFormIterator>
					<TextInput label={false} />
				</SimpleFormIterator>
			</ArrayInput>
		</SimpleForm>
	</Edit>
);
